import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm } from 'antd';
import { TableWrapper } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';


interface FormItemProps {
  lecturerList: any[] | undefined; 
  summery: any[] | undefined;  
  hiddenColumns: string[];  
  onCellClick: (month, value) => void;
}

const SALESLPTable = ({lecturerList, summery, hiddenColumns, onCellClick}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const columns: ColumnsType<any> = [
    {
      title: '강사명',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: '100px',
      align: 'center',
    },          
    {
      title: '1월',
      dataIndex: 'month_01',
      key: 'month_01',
      width: 'auto',
      align: 'right',      
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('01', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }         
    },       
    {
      title: '2월',
      dataIndex: 'month_02',
      key: 'month_02',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('02', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '3월',
      dataIndex: 'month_03',
      key: 'month_03',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('03', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '4월',
      dataIndex: 'month_04',
      key: 'month_04',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('04', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '5월',
      dataIndex: 'month_05',
      key: 'month_05',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('05', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '6월',
      dataIndex: 'month_06',
      key: 'month_06',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('06', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '7월',
      dataIndex: 'month_07',
      key: 'month_07',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('07', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '8월',
      dataIndex: 'month_08',
      key: 'month_08',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('08', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '9월',
      dataIndex: 'month_09',
      key: 'month_09',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('09', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '10월',
      dataIndex: 'month_10',
      key: 'month_10',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('10', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '11월',
      dataIndex: 'month_11',
      key: 'month_11',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('11', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '12월',
      dataIndex: 'month_12',
      key: 'month_12',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('12', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    }, 
    {
      title: '누계',
      dataIndex: 'month_sum',
      key: 'month_sum',
      width: '100px',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('ALL', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : '0'
        )
      }  
    },                                                 
  ];

  /* ======================================================
  * events
  * ====================================================== */ 

  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={lecturerList}
          columns={columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0)}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          summary={pageData => {
            let tot_month = 0;
            let tot_month01 = 0;
            let tot_month02 = 0;
            let tot_month03 = 0;
            let tot_month04 = 0;
            let tot_month05 = 0;
            let tot_month06 = 0;
            let tot_month07 = 0;
            let tot_month08 = 0;
            let tot_month09 = 0;
            let tot_month10 = 0;
            let tot_month11 = 0;
            let tot_month12 = 0;

            pageData.forEach(({ month_01, month_02, month_03, month_04, month_05, month_06, month_07, month_08, month_09, month_10, month_11, month_12, month_sum }) => {

              tot_month += month_sum?month_sum:0;
              tot_month01 += month_01?month_01:0;
              tot_month02 += month_02?month_02:0;
              tot_month03 += month_03?month_03:0;
              tot_month04 += month_04?month_04:0;
              tot_month05 += month_05?month_05:0;
              tot_month06 += month_06?month_06:0;
              tot_month07 += month_07?month_07:0;
              tot_month08 += month_08?month_08:0;
              tot_month09 += month_09?month_09:0;
              tot_month10 += month_10?month_10:0;
              tot_month11 += month_11?month_11:0;
              tot_month12 += month_12?month_12:0;
            });

            return (
              <>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7'}}>
                  <Table.Summary.Cell  index={0} align='center'>합계</Table.Summary.Cell>
                  {(hiddenColumns.findIndex((col)=>col === 'month_01') < 0) && (<Table.Summary.Cell  index={1} align='right'><a onClick={()=> onCellClick('01', '')}>{tot_month01.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_02') < 0) && (<Table.Summary.Cell  index={2} align='right'><a onClick={()=> onCellClick('02', '')}>{tot_month02.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_03') < 0) && (<Table.Summary.Cell  index={3} align='right'><a onClick={()=> onCellClick('03', '')}>{tot_month03.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_04') < 0) && (<Table.Summary.Cell  index={4} align='right'><a onClick={()=> onCellClick('04', '')}>{tot_month04.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_05') < 0) && (<Table.Summary.Cell  index={5} align='right'><a onClick={()=> onCellClick('05', '')}>{tot_month05.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_06') < 0) && (<Table.Summary.Cell  index={6} align='right'><a onClick={()=> onCellClick('06', '')}>{tot_month06.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_07') < 0) && (<Table.Summary.Cell  index={7} align='right'><a onClick={()=> onCellClick('07', '')}>{tot_month07.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_08') < 0) && (<Table.Summary.Cell  index={8} align='right'><a onClick={()=> onCellClick('08', '')}>{tot_month08.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_09') < 0) && (<Table.Summary.Cell  index={9} align='right'><a onClick={()=> onCellClick('09', '')}>{tot_month09.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_10') < 0) && (<Table.Summary.Cell  index={10} align='right'><a onClick={()=> onCellClick('10', '')}>{tot_month10.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_11') < 0) && (<Table.Summary.Cell  index={11} align='right'><a onClick={()=> onCellClick('11', '')}>{tot_month11.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_12') < 0) && (<Table.Summary.Cell  index={12} align='right'><a onClick={()=> onCellClick('12', '')}>{tot_month12.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  <Table.Summary.Cell  index={13} align='right'><a onClick={()=> onCellClick('ALL', '')}>{tot_month.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>
                </Table.Summary.Row>
                {(!!summery && summery.length > 0) && (
                  <>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7'}}>
                  <Table.Summary.Cell  index={0} align='center'>운영비외</Table.Summary.Cell>
                  {(hiddenColumns.findIndex((col)=>col === 'month_01') < 0) && (<Table.Summary.Cell  index={1} align='right'><a onClick={()=> onCellClick('01', '')}>{(summery[0].month_01-tot_month01).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_02') < 0) && (<Table.Summary.Cell  index={2} align='right'><a onClick={()=> onCellClick('02', '')}>{(summery[0].month_02-tot_month02).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_03') < 0) && (<Table.Summary.Cell  index={3} align='right'><a onClick={()=> onCellClick('03', '')}>{(summery[0].month_03-tot_month03).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_04') < 0) && (<Table.Summary.Cell  index={4} align='right'><a onClick={()=> onCellClick('04', '')}>{(summery[0].month_04-tot_month04).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_05') < 0) && (<Table.Summary.Cell  index={5} align='right'><a onClick={()=> onCellClick('05', '')}>{(summery[0].month_05-tot_month05).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_06') < 0) && (<Table.Summary.Cell  index={6} align='right'><a onClick={()=> onCellClick('06', '')}>{(summery[0].month_06-tot_month06).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_07') < 0) && (<Table.Summary.Cell  index={7} align='right'><a onClick={()=> onCellClick('07', '')}>{(summery[0].month_07-tot_month07).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_08') < 0) && (<Table.Summary.Cell  index={8} align='right'><a onClick={()=> onCellClick('08', '')}>{(summery[0].month_08-tot_month08).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_09') < 0) && (<Table.Summary.Cell  index={9} align='right'><a onClick={()=> onCellClick('09', '')}>{(summery[0].month_09-tot_month09).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_10') < 0) && (<Table.Summary.Cell  index={10} align='right'><a onClick={()=> onCellClick('10', '')}>{(summery[0].month_10-tot_month10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_11') < 0) && (<Table.Summary.Cell  index={11} align='right'><a onClick={()=> onCellClick('11', '')}>{(summery[0].month_11-tot_month11).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_12') < 0) && (<Table.Summary.Cell  index={12} align='right'><a onClick={()=> onCellClick('12', '')}>{(summery[0].month_12-tot_month12).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  <Table.Summary.Cell  index={13} align='right'><a onClick={()=> onCellClick('ALL', '')}>{(summery[0].month_sum-tot_month).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>
                </Table.Summary.Row>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7'}}>
                  <Table.Summary.Cell  index={0} align='center'>합계 II</Table.Summary.Cell>
                  {(hiddenColumns.findIndex((col)=>col === 'month_01') < 0) && (<Table.Summary.Cell  index={1} align='right'><a onClick={()=> onCellClick('01', '')}>{(summery[0].month_01).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_02') < 0) && (<Table.Summary.Cell  index={2} align='right'><a onClick={()=> onCellClick('02', '')}>{(summery[0].month_02).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_03') < 0) && (<Table.Summary.Cell  index={3} align='right'><a onClick={()=> onCellClick('03', '')}>{(summery[0].month_03).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_04') < 0) && (<Table.Summary.Cell  index={4} align='right'><a onClick={()=> onCellClick('04', '')}>{(summery[0].month_04).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_05') < 0) && (<Table.Summary.Cell  index={5} align='right'><a onClick={()=> onCellClick('05', '')}>{(summery[0].month_05).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_06') < 0) && (<Table.Summary.Cell  index={6} align='right'><a onClick={()=> onCellClick('06', '')}>{(summery[0].month_06).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_07') < 0) && (<Table.Summary.Cell  index={7} align='right'><a onClick={()=> onCellClick('07', '')}>{(summery[0].month_07).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_08') < 0) && (<Table.Summary.Cell  index={8} align='right'><a onClick={()=> onCellClick('08', '')}>{(summery[0].month_08).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_09') < 0) && (<Table.Summary.Cell  index={9} align='right'><a onClick={()=> onCellClick('09', '')}>{(summery[0].month_09).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_10') < 0) && (<Table.Summary.Cell  index={10} align='right'><a onClick={()=> onCellClick('10', '')}>{(summery[0].month_10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_11') < 0) && (<Table.Summary.Cell  index={11} align='right'><a onClick={()=> onCellClick('11', '')}>{(summery[0].month_11).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  {(hiddenColumns.findIndex((col)=>col === 'month_12') < 0) && (<Table.Summary.Cell  index={12} align='right'><a onClick={()=> onCellClick('12', '')}>{(summery[0].month_12).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>)}
                  <Table.Summary.Cell  index={13} align='right'><a onClick={()=> onCellClick('ALL', '')}>{(summery[0].month_sum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a></Table.Summary.Cell>
                </Table.Summary.Row>                
                  </>
                )}
              </>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESLPTable;
